import './assets/styles/main.scss'

import Vue from 'vue'
import App from '@/App.vue'
import Router from 'vue-router'
import NestedMenu from '@/components/NestedMenu'
import routes from '@/routes'
import AOS from 'aos'
import 'aos/dist/aos.css'

Vue.use(Router)
Vue.use(NestedMenu)

Vue.config.productionTip = false

const router = new Router({
  mode: 'hash',
  routes: routes
})

new Vue({
  created() {
    AOS.init({
      delay: 50, // values from 0 to 3000, with step 50ms
      duration: 1000, // values from 0 to 3000, with step 50ms
      easing: 'ease-in-out', // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: true, // whether elements should animate out while scrolling past them
      anchorPlacement: 'top-bottom',
    })
  },
  router,
  render: h => h(App)
}).$mount('#app')
